import React, { useContext } from 'react';
import { useLang } from '../../../_LangContext'
import { UIIconSelect } from '../basic';

const UISelectMapArea = ({ onChange, value }) =>
{
	const { getText } = useLang();

	const options = [
		{
			value: 'all',
			label: getText('all'),
		},
		{
			value: 'w',
			label: getText('zone-w'),
		},
		{
			value: 'c',
			label: getText('zone-c'),
		},
		{
			value: 'e',
			label: getText('zone-e'),
		},
		{
			value: 'ar',
			label: 'AR',
		},
	];

	return (
		<UIIconSelect
			className = "filter map-area"
			iconClass= "icon map-area"
			options={options}
			value={value}
			onChange={onChange}
		/>
	);
};

export default UISelectMapArea;
